import { UploadSuccessIcon } from 'features/verify/ui/images/upload-successs';
import { css } from 'linaria';
import { styled } from 'linaria/react';
import { sendEvent } from 'model/helpers/events.model';
import { finishVerificationFx } from 'model/flows/verification.model';
import { screenHistoryPush, ScreenName } from 'model/helpers/screens-history';
import { useLocalization } from 'model/localization.model';
import { Fragment, h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { Button } from 'ui/atoms/button';
import { Footer } from 'ui/footer';

import { Spinner } from 'ui/spinner';

export const Completed = () => {
	const t = useLocalization();
	const [isLoading, changeIsLoading] = useState(false);
	const [start] = useState(Date.now());

	useEffect(() => {
		screenHistoryPush(ScreenName.flow_completed);
		setTimeout(() => {
			sendEvent({
				event: 'flow_completed_screen_shown',
			});
		}, 20)
	}, []);

	const handleDone = async () => {
		changeIsLoading(true);
		await finishVerificationFx();
		sendEvent({
			event: 'flow_completed_finish',
			event_attributes: {
				duration: Date.now() - start,
			},
		});
	};

	return (
		<Fragment>
			<Wrapper>
				<Middle>
					<UploadSuccessIcon className={icon}/>
					<Title>{t('mobile.finish.title')}</Title>
					<Subtitle>
						{t('mobile.finish.subtitle')}
					</Subtitle>
				</Middle>
				<Button
					className={btn}
					disabled={isLoading}
					type={'primary'}
					onClick={handleDone}
					name={'mobile.finish.btn'}
				>
					{isLoading ?
						<Spinner size={23}/> :
						t('mobile.finish.btn')
					}
				</Button>
			</Wrapper>
			<Footer/>
		</Fragment>
	);
};

const Wrapper = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	padding: 0 32px;
`;

const Middle = styled.div`
	margin: auto 0;
	padding: 16px;
`;

const Title = styled.h1`
	text-align: center;
	font-size: 26px;
	line-height: 32px;
	font-weight: bold;
`;

const Subtitle = styled.h2`
	font-size: 15px;
	line-height: 24px;
	font-weight: normal;
	text-align: center;
`;
const btn = css`
	margin-bottom: 8px;
`;
const icon = css`
	margin: 0 auto 64px;
`;
